import { Combinator } from "./combinator.js";
import { Selector } from "./selector.js";
/**
 * {@link https://drafts.csswg.org/selectors/#relative-selector}
 *
 * @public
 */
export class Relative extends Selector {
    static of(combinator, selector) {
        return new Relative(combinator, selector);
    }
    _combinator;
    _selector;
    constructor(combinator, selector) {
        super("relative", selector.specificity);
        this._combinator = combinator;
        this._selector = selector;
    }
    get combinator() {
        return this._combinator;
    }
    get selector() {
        return this._selector;
    }
    matches() {
        return false;
    }
    equals(value) {
        return (value instanceof Relative &&
            value._combinator === this._combinator &&
            value._selector.equals(this._selector));
    }
    *[Symbol.iterator]() {
        yield this;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            combinator: this._combinator,
            selector: this._selector.toJSON(),
        };
    }
    toString() {
        const combinator = this._combinator === Combinator.Descendant ? "" : `${this._combinator} `;
        return `${combinator}${this._selector}`;
    }
}
/**
 * {@link https://drafts.csswg.org/selectors/#typedef-relative-selector}
 */
// const parseRelative = map(pair(parseCombinator, parseComplex), (result) => {
//   const [combinator, selector] = result;
//   return Relative.of(combinator, selector);
// });
//# sourceMappingURL=relative.js.map